// extracted by mini-css-extract-plugin
export default {"container":"top-menu_container__YSJGz"};